import { Box, Card, CardActionArea, CardContent, Skeleton } from "@mui/material";

export default function SuggestionSkeleton() {
  return (
    <Box sx={{ flexGrow: 1, p: 2 }}>
      <Box
        component="div"
        sx={{
          display: "grid",
          gridTemplateColumns: {
            xs: "1fr",
            sm: "1fr 1fr",
            md: "1fr 1fr 1fr",
            lg: "1fr 1fr 1fr 1fr"
          },
          gap: 2
        }}>
        {[1, 2, 3].map((index) => (
          <Card
            key={`skeleton-${index}`}
            sx={{
              width: "100%",
              height: 250,
              boxShadow: "none",
              borderRadius: 2,
              border: "1px solid #e0e0e0",
              backgroundColor: "#fff",
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between"
            }}>
            <CardActionArea sx={{ height: "100%" }}>
              <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
                <Skeleton variant="circular" width={80} height={80} sx={{ borderRadius: "50%" }} />
              </Box>
              <CardContent
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  gap: 1,
                  pt: 2,
                  pb: 1
                }}>
                <Skeleton variant="rounded" width={80} height={10} />
                <Skeleton variant="rounded" width={80} height={10} />
              </CardContent>
              <Box sx={{ display: "flex", justifyContent: "center", mb: 2 }}>
                <Skeleton variant="rounded" width={140} height={30} />
              </Box>
            </CardActionArea>
          </Card>
        ))}
      </Box>
    </Box>
  );
}
